import { TaskFilterType } from "features/authSlice";
import { NeedStatus, PendingItem } from "pages/dashboard/home/dashboardService";

/**
 * Returns a category `TaskFilterType` for a given `PendingItem` for the
 * purposes of counting tasks in the sidebar.
 * @param item 
 * @returns 
 */
export const getTaskStatusForCount = (item: PendingItem): TaskFilterType => {
  if (!item.needStatus) {
    return TaskFilterType.ToDo;
  }

  switch (item.needStatus.toLowerCase()) {
    case NeedStatus.ReviewNeeded.toLowerCase():
      return TaskFilterType.UnderReview;
    case NeedStatus.Satisfied.toLowerCase():
      return TaskFilterType.Complete;
    case NeedStatus.New.toLowerCase():
    case NeedStatus.PendingDocuments.toLowerCase():
    case NeedStatus.Unknown.toLowerCase():
    default:
      return TaskFilterType.ToDo;
  }
};

/**
 * Returns a category `TaskFilterType` for a given `PendingItem` for the
 * purposes of sorting tasks into tabs.
 * 
 * This method is identical to `getTaskStatusForCount` but considers the
 * "Additional Documentation" item which should only reside in the "ToDo"
 * category but not be included in the sidebar count.
 * @param item 
 * @returns 
 */
export const getTaskStatus = (item: PendingItem): TaskFilterType => {
  if (item.title.includes("Additional Documentation")) {
    return TaskFilterType.ToDo;
  }

  return getTaskStatusForCount(item);
};